<template>
  <div>
    <section class="dialogsBox" v-show="auditIsShow">
      <div>
        <h3>
          待开票批量审核
          <h4>{{ "已选中" + ids.length + "条费用" }}</h4>
        </h3>
        <a @click="rejectCancel" class="close">
          <a-icon type="close-circle" style="font-size: 30px; color: #333" />
        </a>
        <ul>
          <li>
            <label> <i>*</i>开票日期： </label>
            <a-date-picker v-model="invoice_date" />
          </li>
          <li>
            <label> <i>*</i>票据： </label>
            <a-radio-group v-model="is_ticket">
              <a-radio :value="2">票据齐全</a-radio>
              <a-radio :value="1">票据不全</a-radio>
            </a-radio-group>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="batchSubmit">确定</a-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      invoice_date: "",
      ids: [],
      auditIsShow: true,
      is_ticket: ""
    };
  },
  mounted() {
    if (this.batchInvoiceIds != undefined) {
      this.getIds();
    }
  },
  props: {
    batchInvoiceIds: Array
  },
  watch: {
    batchInvoiceIds() {
      this.getIds();
    }
  },

  methods: {
    verify() {
      let fls = true;
      if (this.invoice_date == "") {
        fls = false;
        this.$message.warning("请选择开票日期");
        return fls;
      }
      if (this.is_ticket == "") {
        fls = false;
        this.$message.warning("请选择票据信息");
        return fls;
      }
      return fls;
    },
    batchSubmit() {
      let fls = this.verify();
      if (fls) {
        this.auditIsShow = false;
        this.auditPassHttp();
      }
    },
    auditPassHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/financeCheckPassTicket";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        ids: JSON.stringify(this.ids),
        is_ticket: this.is_ticket,
        invoice_date: moment(this.invoice_date).format("YYYY-MM-DD")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.auditIsShow = true;
          this.$emit("hideInDialogBatchInvoiceAudit", true);
          this.$message.success("批量操作成功");
        } else {
          this.$emit("hideInDialogBatchInvoiceAudit", false);
          this.$message.error(res.data.message);
        }
      });
    },
    getIds() {
      this.ids = this.batchInvoiceIds;
    },
    rejectCancel() {
      this.$emit("hideInDialogBatchInvoiceAudit", false);
    }
  }
};
</script>
<style lang="less" scoped>
.dialogsBox > div h3 {
  h4 {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #666;
    margin-top: 10px;
  }
}
</style>
